// eslint-disable-next-line import/prefer-default-export
export const ButtonsProperty = {
  IsDisabled: 'isDisabled',
  IsLoading: 'isLoading',
  SubmitButtonTitle: 'submitButtonTitle',
  SubmitButtonFillType: 'submitButtonFillType',
  ResetButtonTitle: 'resetButtonTitle',
  ShowResetButton: 'showResetButton',
};
